/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { integer, sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const patientCommunicationPreferences = sqliteTable('patient_communication_preferences', {
  id: text('id').primaryKey().notNull(),
  org_id: text('org_id'),
  patient_id: text('patient_id'),
  whatsapp_opt_in: integer('whatsapp_opt_in'),
  whatsapp_opt_out_at: text('whatsapp_opt_out_at'),
  whatsapp_opt_out_reason: text('whatsapp_opt_out_reason'),
  sms_opt_in: integer('sms_opt_in'),
  email_opt_in: integer('email_opt_in'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
  updated_by: text('updated_by'),
});
